import { Component } from '@angular/core';
import { PaymentPaymentOptionCardFormAbstractForm } from '../payment.payment.option.card.form.abstract-form';

@Component({
    'selector': 'payment-payment-option-card-form-default',
    'templateUrl': './payment.payment.option.card.form.default.component.html',
    'providers': [],
    'styleUrls': ['../../../../../../payment.component.scss']
})
export class PaymentPaymentOptionCardFormDefaultComponent extends
    PaymentPaymentOptionCardFormAbstractForm {
}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/payment/payment/option/card/option/form/default/payment.payment.option.card.form.default.component.ts